import { request } from "../libs";
const timeout = 3000;

export default function logout() {
	return request(
		"/server/auth/logout",
		{ method: "GET" },
		timeout
	);
}



// WEBPACK FOOTER //
// ./src/api/logout.js